import { eventTracker } from "../components/generic/Utils/eventTracker";
import { editableCookieTypeKeys } from "../components/specific/CookieConsent/CustomizeCookiePreferences/data";

const CookieUtils = {
  setCookie(cookieName, cookieValue) {
    new Cookies("/", window.location.hostname, { secure: true }).set(cookieName, cookieValue, 365);
  },

  getCookie(cookieName) {
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find((c) => c.startsWith(`${cookieName}=`));
    return cookie ? decodeURIComponent(cookie.split("=")[1]) : null;
  },

  getCookieValueToSet(cookieNames, cookieValueForAllTypes, cookiesData) {
    let cookieValues = {};
    if(cookieValueForAllTypes !== null) {
      cookieNames.forEach(cookieName => {
        cookieValues[cookieName] = cookieValueForAllTypes;
      });
    } else {
      cookieValues = CookieUtils.getEditableCookieValues(cookieNames, cookiesData);
    }
    return JSON.stringify(cookieValues);
  },

  getEditableCookieValues(cookieNames, cookiesData) {
    let cookieValues = {};
    cookieNames.forEach(cookieName => {
      cookieValues[cookieName] = cookiesData.find(cookieData => cookieData.key === cookieName).enabled;
    });
    return cookieValues;
  },

  handleEventTracking(eventAction, cookiesData = null) {
    let payload = {};
    if(eventAction === chrEventConstants.action.CLICKED_SAVE_COOKIE_PREFERENCES) {
      payload = CookieUtils.getEditableCookieValues(editableCookieTypeKeys, cookiesData);
    }
    eventTracker(eventAction, payload);
  },

  handleAnalyticalTracking(isEnabled, gaMeasurementId) {
    if (!isEnabled) {
      CookieUtils.disableGATracking(gaMeasurementId);
      CookieUtils.disableHotjarTracking();
    }
  },

  disableGATracking(gaMeasurementId) {
    if (gaMeasurementId) {
      window[`ga-disable-${gaMeasurementId}`] = true;
    }
    window.gtag = function () {};
    CookieUtils.clearAnalyticCookies(/^_ga/);
  },

  disableHotjarTracking() {
    if (window.hj) {
      window.hj = function () {
        return;
      };
    }

    CookieUtils.clearAnalyticCookies(/^_hj/);
  },

  clearAnalyticCookies(regex) {
    const cookies = document.cookie.split(";");

    cookies.forEach(cookie => {
      const cookieName = cookie.trim().split("=")[0];
      if (regex.test(cookieName)) {
        CookieUtils.deleteCookie(cookieName);
      }
    });
  },

  deleteCookie(cookieName) {
    const domainName = window.location.hostname;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domainName};`;
    const domainParts = domainName.split(".");
    if (domainParts.length > 2) {
      const rootDomain = domainParts.slice(-2).join(".");
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${rootDomain};`;
    }
  },

  getSafelyParsedCookieValue(cookieName) {
    let cookie;
    try {
      cookie = JSON.parse(CookieUtils.getCookie(cookieName) || "null");
    } catch (error) {
      cookie = null;
      console.log("Invalid JSON in cookie:", error);
    }
    return cookie;
  }
}

export default CookieUtils;
